import { render, staticRenderFns } from "./UnidadeRegionalMunicipios.vue?vue&type=template&id=11f35fd6"
import script from "./UnidadeRegionalMunicipios.vue?vue&type=script&lang=js"
export * from "./UnidadeRegionalMunicipios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports